import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "onChange", "getters", "notFoundLabel", "onListOpen", "loading", "className", "value", "renderValue", "multiple", "disabled", "invert"];
import React, { forwardRef, useEffect, useRef } from 'react';
import { useDidUpdateEffect, useFlag } from '@carnica/utils/hooks';
import { composePreparedProps } from "./utils";
import { SelectField } from "./SelectField";
import { SelectList } from "./SelectList";
var SelectRender = function SelectRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    items = _composePreparedProps.items,
    onChange = _composePreparedProps.onChange,
    getters = _composePreparedProps.getters,
    notFoundLabel = _composePreparedProps.notFoundLabel,
    onListOpen = _composePreparedProps.onListOpen,
    loading = _composePreparedProps.loading,
    className = _composePreparedProps.className,
    value = _composePreparedProps.value,
    renderValue = _composePreparedProps.renderValue,
    multiple = _composePreparedProps.multiple,
    disabled = _composePreparedProps.disabled,
    invert = _composePreparedProps.invert,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var wrapperRef = useRef(null);
  useEffect(function () {
    if (disabled) {
      setIsOpen.off();
    }
  }, [disabled]);
  useDidUpdateEffect(function () {
    onListOpen === null || onListOpen === void 0 ? void 0 : onListOpen(isOpen);
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectField, _extends({
    disabled: disabled,
    getItemLabel: getters.getItemLabel,
    invert: invert,
    isOpen: isOpen,
    multiple: multiple,
    onClick: setIsOpen.toggle,
    ref: ref,
    renderValue: renderValue,
    value: value,
    wrapperRef: wrapperRef
  }, otherProps, {
    "data-t-id": "components-Select"
  })), /*#__PURE__*/React.createElement(SelectList, _extends({
    anchorRef: wrapperRef,
    isOpen: isOpen,
    items: items,
    loading: loading,
    multiple: multiple,
    notFoundLabel: notFoundLabel,
    onChange: onChange,
    onClickOutside: setIsOpen.off,
    value: value
  }, getters)));
};
export var Select = /*#__PURE__*/forwardRef(SelectRender);